import * as React from 'react';

var EXTERNAL_USAGE = {
  isInternalUsage: false
};
var INTERNAL_USAGE = {
  isInternalUsage: true
};
var TrackingContext = /*#__PURE__*/React.createContext(EXTERNAL_USAGE);
var SkipTrackingProvider = function SkipTrackingProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(TrackingContext.Provider, {
    value: INTERNAL_USAGE
  }, children);
};
var EnableTrackingProvider = function EnableTrackingProvider(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement(TrackingContext.Provider, {
    value: EXTERNAL_USAGE
  }, children);
};
var useTrackingContext = function useTrackingContext() {
  return React.useContext(TrackingContext);
};

export { EnableTrackingProvider, SkipTrackingProvider, useTrackingContext };
//# sourceMappingURL=TrackingContextProvider.js.map
